export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            关于51影视
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            用心做好每一个追剧瞬间
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
            <div className="flex-shrink-0 w-full md:w-64">
              <div className="aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20warm%20abstract%20cinematic%20visual%2C%20comfortable%20sofa%2C%20soft%20ambient%20lighting%2C%20warm%20interior%20design%2C%20minimalist%20aesthetic%2C%20inviting%20atmosphere&width=600&height=450&seq=about-img-2026&orientation=landscape"
                  alt="51影视 · 沉浸式追剧空间"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                51影视成立于2020年，致力于为广大剧迷提供最全面的电视剧在线观看服务。
                我们深知追剧的快乐——找到一部好剧、一口气看完全集的畅快感，
                正是我们不断优化平台的动力。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台目前已收录超过2000部电视剧全集资源，涵盖国产剧、港台剧、日韩剧、
                欧美剧等全品类，每日同步更新最新剧集。我们坚持高清画质、极速缓冲、
                纯净无广告的核心原则，让每一位用户都能享受流畅舒适的追剧体验。
              </p>
              <div className="flex flex-wrap gap-4 text-xs md:text-sm text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <i className="ri-check-line text-accent-500"></i>
                  2000+ 剧集资源
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-check-line text-accent-500"></i>
                  每日准时更新
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-check-line text-accent-500"></i>
                  全高清1080P
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}